import React, { Component } from 'react';
import { Input, Button, IconButton } from '@material-ui/core';
import './Landingpage.css'
import landing1 from '../assets/images/landing2.png'
import logo from '../assets/images/logo.jpg'

class Landingpage extends Component {
  	constructor (props) {
		super(props)
		this.state = {
			url: '',
            video: false,
			audio: false,
			screen: false,
		}
	}

	handleChange = (e) => this.setState({ url: e.target.value })

	join = () => {
		if (this.state.url !== "") {
			var url = this.state.url.split("/")
			window.location.href = `/${url[url.length-1]}`
		} else {
			var url = Math.random().toString(36).substring(2, 7)
			window.location.href = `/${url}`
		}
	}
    connect = () => this.setState({ askForUsername: false }, () => this.getMedia())
   


	render() {
		return (
            <div class="main">
                <div class='img-logo'>
                    <p class="logo-text">World Meet</p>
                    <img src={logo} ></img>
                </div>
                <div class="container-landing">
                    <div class="top-left-section">
                        <h1><span class="first-text">Meet face-to-face</span> with anyone in the <span class="midlle-text">world instantly &</span> Build better relationships</h1>
                        <h5>Invite people to celebrate your occasion with you 
                            and Keep your friends and team in touch using the <span>World Meet</span>
                        </h5>
                        <button class="action-button" onClick={this.join}>Start New Meeting</button>
                        <input type='url' placeholder="Enter meeting link here" size='30' onChange={e => this.handleChange(e)}></input>
                        <span><Button class="join-button"  color='primary' disabled={!this.state.url} onClick={this.join}>Join</Button></span>
                    </div>
                    <div class="right-left-img-section">
                        <img src={landing1}></img>
                    </div>
                </div>

                <div class="card-list">
                    <div class="info1-card-list">
                        <h3>How To Use:</h3>
                        <ol>
                            <li>Click On Start New Meeting </li>
                            <li>Copy Invitation Link and share with Your Friends</li>
                            <li>Now you are Connected</li>
                        </ol>
                    </div>
                    <div class="features-ino-list">
                        <h3>Features are:</h3>
                        <ul>
                            <li>Not Need to be Sign-Up Or Login</li>
                            <li>Everythings are Free</li>
                            <li>Unlimited Timing</li>
                        </ul>
                    </div>
                </div>
            </div>
		)
	}
}

export default Landingpage;